import axios from 'axios'
import { baseURL_en, baseURL_ru, serverUrl_ru, serverUrl_en } from '../config'
import {getIsRuServer} from './getIsRuServer'

const DEFAULT_SERVER = serverUrl_en

export const getCurrentServerUrl = () => {
  const isRuServer = getIsRuServer()
  return isRuServer ? serverUrl_ru : DEFAULT_SERVER
}

export const getCurrentServer = () => {
  const isRuServer = getIsRuServer()
  return isRuServer ? baseURL_ru : baseURL_en
}

class AxiosWrapper {
  axios = axios.create()

  changeURL = async () => {
    const currentServer = getCurrentServer()

    console.log('currentServer', currentServer)
    console.log('this.baseURL', this.baseURL)

    if (!this.baseURL) {
      this.baseURL = currentServer
    } else if (this.baseURL === baseURL_ru) {
      this.baseURL = baseURL_en
    } else {
      this.baseURL = baseURL_ru
    }

    localStorage.setItem('currentServer', this.baseURL)

    console.log('CHANGE URL this.baseUrl', this.baseURL)

    this.axios = axios.create({
      baseURL: `${this.baseURL}/`,
      responseType: 'json',
      timeout: 30000
    })

    this.request = (payload) => {
      console.log('request CALL', payload)
      return this.axios.request(payload)
    }
  }

  getCurrentServer = () => {
    return this.baseURL
  }
}

const axiosWrapper = new AxiosWrapper()
axiosWrapper.changeURL()
export default axiosWrapper
